import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import App from "../../models/app/app.model";

interface AppStateType {
    data: App | null
    onboarded: boolean
}

const initialState: AppStateType = {
    data: null,
    onboarded: false
};

export const AppSlice = createSlice({
    name: "App",
    initialState: initialState,
    reducers: {
        setAppData: (state, action: PayloadAction<App>) => {
            state.data = action.payload;
        },
        setAppError: (state) => {
            state.data = {
                show_ads: false,
                necessary_update: false,
                posts_per_page: {
                    home: 60,
                    other: 50
                },
                user_posts_limit: 5,
                transport: [
                    {
                        country: "Kosovë",
                        country_code: "XK",
                        fee: 2
                    },
                    {
                        country: "Maqedoni V.",
                        country_code: "MK",
                        fee: 3
                    },
                    {
                        country: "Shqipëri",
                        country_code: "AL",
                        fee: 5
                    }
                ]
            }
        },
        setOnboarded: (state, action: PayloadAction<boolean>) => {
            state.onboarded = action.payload;
        }
    }
});

export default AppSlice.reducer;
export const {
    setAppData,
    setOnboarded
} = AppSlice.actions;